import {productCardOptimization} from '../../utils/constants/signalmanConstants';

class ProductOptimizationTest {
  constructor() {
    this.flag = productCardOptimization;
    this.dataLayerPush();
  }

  dataLayerPush() {
    return window.dataLayer.push({
      event: 'ab_test_group',
      ab_test_name: '2024 12 12 product card optimization',
      ab_test_location: 'plp',
      ab_test_group: this.flag
    });
  }
}

jQuery(
  () => (ProductCatalog.ProductOptimizationTest = new ProductOptimizationTest())
);
